import { gql } from '@apollo/client';

export const fetchCustomers = gql`
  query fetchCustomersForTransactionAccount($id: ID!, $viewTaxRelatedInfo: Boolean) {
    transactionAccount(id: $id) {
      id
      availableShipToParties(viewTaxRelatedInfo: $viewTaxRelatedInfo) {
        totalCount
        nodes {
          name
          id
          isActive
        }
      }
    }
  }
`;
